// Entity meaning: company, branch or agent

import {Types} from "@Common/types";

export const COMPANY_LEVEL = 3;
export const BRANCH_LEVEL  = 4;
export const OFFICE_LEVEL  = BRANCH_LEVEL;
export const AGENT_LEVEL   = 5;
export const USER_LEVEL    = AGENT_LEVEL;

export const USER_LEVEL_LABELS = {
    [COMPANY_LEVEL]:    "Company",
    [BRANCH_LEVEL]:     "Branch",
    [AGENT_LEVEL]:      "Agent",
} as const;

export const USER_LEVEL_REVERSE_LABELS = Object.fromEntries(
    Object.entries(USER_LEVEL_LABELS)
    .map(([userLevel, label]) => [label, parseInt(userLevel)])
) as Record<typeof USER_LEVEL_LABELS[keyof typeof USER_LEVEL_LABELS], Types.Apis.Models.UserLevel>;

